<!--<div class="card flex justify-content-center gap-2">
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<button (click)="Confirm()" >Confirm</button>
| date:'yyyy-MM-dd'
</div>-->

@if (modifyBooking) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 500; margin-top:0px">
    <div class="loaderforPassenger_forBooking">
      <span class="message">Modify Booking In Process</span>
      <span class="loadspan"></span>
    </div>
  </div>
}
<div class="container">
  <div style="background-color: #fcf4ed; padding: 10px; border-radius: 5px; justify-content: center; align-items: center; display: flex; ">
    <span class="PassegerHeading">Modify Passenger</span>
  </div>
  @if (!passengerSelected) {
    <div style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 7px; margin-top: 20px; ">
      <span class="PassegerHeading">Select Passenger</span>
      <form (ngSubmit)="selectPassenger()">
        <div style="display:flex">
          @for (obj of  bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
            <div class="passenger-container">
              <div class="passenger-details">
                <div class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="obj.isChecked" name="isChecked{{i}}" id="passenger1{{i}}" />
                  <label for="passenger1{{i}}"></label>
                </div>
                <span style=" font-size: 16px; font-weight: bold;">{{obj.title}} {{obj.firstName}} {{obj.lastName}}</span>
              </div>
            </div>
          }
        </div>
        <button class="button-24" type="submit">Continue</button>
      </form>
    </div>
  }
  @if (passengerSelected) {
    <div class="passenger-form">
      <span class="PassegerHeading">Selected Passenger</span>
      <form #dataForm="ngForm"  (ngSubmit)="Confirm(dataForm)">
        @for (obj of  bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
          <div >
            @if (obj.isChecked) {
              <div class="passenger-form">
                <div class="passenger-header">{{obj.title}} {{obj.firstName}} {{obj.lastName}}</div>
                <div class="row m-0 p-0">
                  <!--<div class="col-sm-12 col-md-4 col-lg-3">
                  <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.mobile? 'label-error':'input-group-label'" for="mobileNumber{{i}}">Mobile Number</label>
                  <input class="new-input-group" [ngClass]="dataFormSubmit  && !obj.mobile? 'invalid-Error':''"
                    type="text" [(ngModel)]="obj.mobile"
                    id="mobileNumber{{i}}"
                    name="mobileNumber{{i}}" pattern="^\+[1-9][0-9]{7,14}$" required #mobileNumber="ngModel" />
                    <span class="error_class" *ngIf="dataFormSubmit  && !obj.mobile">Required Mobile Number</span>
                    <span class="error_class" *ngIf="mobileNumber.invalid && dataFormSubmit&& obj.mobile">Pattern of Mobile No(+xxxx...)</span>
                  </div>-->
                  <div class="col-sm-12 col-md-4 col-lg-3">
                    <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.passportNumber? 'label-error':'input-group-label'" for="passportNumber{{i}}">Passport Number</label>
                    <input class="new-input-group"
                      type="text" [(ngModel)]="obj.passportNumber"
                      id="passportNumber{{i}}" [ngClass]="dataFormSubmit  && !obj.passportNumber? 'invalid-Error':''"
                      name="passportNumber{{i}}" required />
                      @if (dataFormSubmit  && !obj.passportNumber) {
                        <span class="error_class">Required Passport No</span>
                      }
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-3">
                      <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.psdatevalid? 'label-error':'input-group-label'" for="passportExpiry{{i}}">Passport Expiry</label>
                      <input class="new-input-group" [ngClass]="dataFormSubmit  && !obj.psdatevalid? 'invalid-Error':''"
                        type="date" [(ngModel)]="obj.psdatevalid"
                        id="passportExpiry{{i}}" [min]="date"
                        name="passportExpiry{{i}}" required />
                        @if (dataFormSubmit  && !obj.psdatevalid) {
                          <span class="error_class">Required Passport Expiry</span>
                        }
                      </div>
                      <div class="col-sm-12 col-md-4 col-lg-3">
                        <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.email? 'label-error':'input-group-label'" for="email{{i}}">Email</label>
                        <input class="new-input-group" [(ngModel)]="obj.email" type="text" id="email{{i}}" name="email{{i}}" required pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$"
                          [ngClass]="dataFormSubmit  && !obj.email? 'invalid-Error':''" #email="ngModel" />
                          @if (dataFormSubmit  && !obj.email) {
                            <span class="error_class">Required Email</span>
                          }
                          @if (email.invalid && dataFormSubmit&& obj.email) {
                            <span class="error_class">Pattern of Email(abc&#64;xyz.com)</span>
                          }
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-3">
                          <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.paxdob? 'label-error':'input-group-label'" for="birthday{{i}}">Date of Birth</label>
                          <input class="new-input-group" [ngClass]="dataFormSubmit  && !obj.paxdob? 'invalid-Error':''"
                            type="date"  [(ngModel)]="obj.dob"
                            id="birthday{{i}}" (blur)="validateDobForPassengerType(i)"
                            name="birthday{{i}}" required />
                            @if (dataFormSubmit  && !obj.paxdob) {
                              <span class="error_class">Required DOB</span>
                            }
                            <span class="error_class" id="dobvalidate{{i}}"></span>
                          </div>
                          <div class="col-sm-12 col-md-4 col-lg-3">
                            <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.paxNationality? 'label-error':'input-group-label'" for="nationality{{i}}">Nationality</label>
                            <p-select class="segmentDropdown" [options]="countryList"
                              [(ngModel)]="obj.paxNationality" name="paxNationality{{i}}"
                              optionLabel="countryName" optionValue="code"
                              [filter]="true" [showClear]="true" id="paxNationality{{i}}"
                              [ngClass]="{'p-dropdown invalid_Prime_Error ':dataFormSubmit  && !obj.paxNationality}"
                              [required]="true" placeholder="Please Select">
                              <ng-template let-countryList pTemplate="selectedItem">
                                <div>{{ countryList.countryName}}</div>
                              </ng-template>
                            </p-select>
                            @if (dataFormSubmit  && !obj.paxNationality) {
                              <span class="error_class">Required Nationality</span>
                            }
                          </div>
                          <div class="col-sm-12 col-md-4 col-lg-3">
                            <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.countryOfIssuance? 'label-error':'input-group-label'" for="countryOfIssuance{{i}}">Country of Issuance</label>
                            <p-select class="segmentDropdown" [options]="countryList"
                              [(ngModel)]="obj.countryOfIssuance" name="countryOfIssuance{{i}}"
                              optionLabel="countryName" optionValue="code" id="countryOfIssuance{{i}}"
                              [filter]="true" [showClear]="true"
                              [ngClass]="{'p-dropdown invalid_Prime_Error ':dataFormSubmit  && !obj.countryOfIssuance}"
                              [required]="true" placeholder="Please Select">
                              <ng-template let-countryList pTemplate="selectedItem">
                                <div>{{ countryList.countryName}}</div>
                              </ng-template>
                            </p-select>
                            @if (dataFormSubmit  && !obj.countryOfIssuance) {
                              <span class="error_class">Required Country Issue</span>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <!--<div class="row p-0 m-0">-->
                    <!--<div class="maindiv1">
                    <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.paxNationality? 'label-error':'input-group-label'" for="nationality{{i}}">Nationality</label>
                    <p-select class="segmentDropdown" [options]="countryList"
                      optionLabel="countryName" optionValue="code" name="paxNationality{{i}}"
                      [(ngModel)]="obj.paxNationality"
                      [ngClass]="{'p-dropdown invalid_Prime_Error ':dataFormSubmit  && !obj.paxNationality}"
                      [required]="true" placeholder="Please Select">
                    </p-select>
                    <span class="error_class" *ngIf="dataFormSubmit  && !obj.paxNationality">Required Nationality</span>
                  </div>
                  <div class="maindiv1">
                    <label class="input-group-label" [ngClass]="dataFormSubmit  && !obj.countryOfIssuance? 'label-error':'input-group-label'" for="countryOfIssuance{{i}}">Country of Issuance</label>
                    <p-select class="segmentDropdown" [options]="countryList"
                      optionLabel="countryName" optionValue="code" name="countryOfIssuance{{i}}"
                      [(ngModel)]="obj.countryOfIssuance"
                      [ngClass]="{'p-dropdown invalid_Prime_Error ':dataFormSubmit  && !obj.countryOfIssuance}"
                      [required]="true" placeholder="Please Select">
                    </p-select>
                    <span class="error_class" *ngIf="dataFormSubmit  && !obj.countryOfIssuance">Required Country Issue</span>
                  </div>-->
                <!--</div>-->
              </div>
            }
            <div style="width: 100%;text-align: end;  display: flex;padding-top:5px;justify-content:end">
              <p-toast></p-toast>
              <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
              <button class="button-24" type="submit">Confirm</button>
              <button type="button" style="margin-left:5px" (click)="cancel()" class="button-cancel">Cancel</button>
            </div>
          </form>
        </div>
      }
    </div>
